export const getvideoidquery = `
  query getVideoId($orderedpostpartid: Int){
    Video(orderedpostpartid: $orderedpostpartid){
      content
    }
  }
`
